import { createTheme } from '@mui/material/styles';

const Muitheme = createTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
  },
});

export default Muitheme;
